import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export const LogTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    id: "subject",
    accessorKey: "subject_type",
    header: "subject",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (!row?.original?.subject_type && !row?.original?.subject_id)
        return <p>{t(row?.original?.event)}</p>;

      return (
        <p>
          {t(row?.original?.subject_type)}:{" "}
          {row?.original?.subject?.log_label ?? row?.original?.subject_id}
        </p>
      );
    },
  },
  {
    id: "causer",
    accessorKey: "causer",
    header: "causer",
    cell: ({ row }) => {
      return (
        <p>
          {row?.original?.causer?.name
            ? row?.original?.causer?.name
            : row?.original?.causer?.username}
        </p>
      );
    },
  },
  {
    id: "event",
    accessorKey: "event",
    header: "event",
  },
  {
    id: "properties",
    accessorKey: "properties",
    header: "properties",
    cell: ({ row }) => {
      const oldProperties = row?.original?.properties?.old;
      const newProperties = row?.original?.properties?.attributes;
      const { t } = useTranslation("common");
      const [isDropdownOpen, setIsDropdownOpen] = useState(false);

      const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
      };

      if (!oldProperties && !newProperties)
        return (
          <div>
            <p>{t(row?.original?.description)}</p>
          </div>
        );

      if (newProperties) {
        if (Object.keys(newProperties).length === 1) {
          const key = Object.keys(newProperties)[0];
          return (
            <div>
              {oldProperties ? (
                <p>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{" "}
                  {JSON.stringify(oldProperties[key])} {`->`}{" "}
                  {JSON.stringify(newProperties[key])}
                </p>
              ) : (
                <p>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{" "}
                  {JSON.stringify(newProperties[key])}
                </p>
              )}
            </div>
          );
        }
      }

      return (
        <div className="d-flex flex-column justify-content-start">
          <div
            style={{ cursor: "pointer", color: "blue" }}
            onClick={toggleDropdown}
          >
            ({newProperties && Object.keys(newProperties).length}){" "}
            {isDropdownOpen ? t("Hide Properties") : t("Show Properties")}{" "}
            <span>{isDropdownOpen ? "↑" : "↓"}</span>
          </div>
          {isDropdownOpen && (
            <div style={{ marginTop: "10px" }}>
              <h6>{t("Properties")}</h6>
              {Object.keys(newProperties).map((key) => (
                <div key={key} style={{ marginBottom: "-12px" }}>
                  {oldProperties ? (
                    <p>
                      <strong>{key}:</strong>{" "}
                      {JSON.stringify(oldProperties[key])} {"->"}{" "}
                      {JSON.stringify(newProperties[key])}
                    </p>
                  ) : (
                    <p>
                      <strong>{key}:</strong>{" "}
                      {JSON.stringify(newProperties[key])}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    },
  },
  {
    id: "created_at",
    accessorKey: "created_at",
    header: "created_at",
    cell: ({ row }) => {
      if (!row?.original?.updated_at)
        return new Date(row?.original?.created_at).toLocaleString();
      return new Date(row?.original?.updated_at).toLocaleString();
    },
  },
];
